export default __webpack_public_path__ + "static/media/Word-Logo.1efe1c10.svg";